<template>
  <span>
    <span v-show="item.cityName&&item.cityName!=''">会议/活动地点：{{item.cityName}}/</span>
    <span v-show="item.useDay!=''">{{item.useDay}}</span>
    <span v-if="item.activeType&&item.activeType!=''"><i>/</i>{{item.activeType}}</span>
    <span v-if="item.peopleType==1"
          v-show="item.peopleNumber!=''"><i>/</i>{{item.peopleNumber}}人</span>
    <span v-if="item.peopleType==2"
          v-show="item.peopleNumRange!=''"><i>/</i>{{item.peopleNumRange}}</span>
    <span v-show="item.budgetPrice&&item.budgetPrice!=''"><i>/</i>{{item.budgetPrice}}{{item.currency}}</span>
    <span v-for="(values,key) in item.containServiceMap" :key="key">
      <span v-for="(item2,index1) in values" :key="index1">
        {{item2}}
        <span v-if="index1!=(values.length-1)">+</span>
      </span>
    </span>
  </span>
</template>

<script>
export default {
  props:{
    item:{
      type:Object,
      default:()=>{return {}}
    }
  }
}
</script>

<style>

</style>